export default "__VITE_ASSET__B$j3L3vm__"